import { api } from './api';
import {
  CyclesInterface,
  InviteInterface,
  LastManagerInterface,
  VacationManagerInterface,
  RankingKPI,
  UserGroupInterface,
  ParticipationsEvaluated_Interface,
} from 'types/user';
import { SortPagination } from 'utils/paginations';
import { string } from 'prop-types';
import { actionLog, pushPlayerAction } from './actionlog.service';
import { DeleteReasonOption, GENERIC_DELETE_ERROR_MESSAGE } from 'components/task-item/delete-rules';

export async function getKPIDestaqueCultura(behavior: string, player?: string): Promise<RankingKPI> {
  const dummy = { position: 0, total_positions: 0 };

  try {
    const payload = {
      behavior,
      player,
      start: new Date(2022, 9, 1),
      end: new Date(),
    };
    const { data } = await api.post('find/destaque_cultura', payload);
    // console.log('getKPIDestaqueCultura', behavior, data);

    if (!Array.isArray(data)) {
      return dummy;
    } else {
      if (data.length) {
        const { position, total_positions, points } = data[0] as RankingKPI;
        return { position, total_positions, points };
      } else {
        return dummy;
      }
    }
  } catch (e) {
    // console.log('ERROR: getKPIDestaqueCultura', e);
    return dummy;
  }
}

export async function getKPIGaleriaReconhecimento(player?: string, start?: any, end?: any): Promise<RankingKPI> {
  const dummy = { position: 0, total_positions: 0 };

  try {
    const payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
    };
    const { data } = await api.post('find/galeria_conhecimento', payload);
    // console.log('getKPIDestaqueCultura', behavior, data);

    if (!Array.isArray(data)) {
      return dummy;
    } else {
      if (data.length) {
        // const { position, total_positions } = data[0] as RankingKPI;
        return data[0] as RankingKPI;
      } else {
        return dummy;
      }
    }
  } catch (e) {
    // console.log('ERROR: getKPIDestaqueCultura', e);
    return dummy;
  }
}

export async function getKPIPointsOnline(player?: string, filter?: any, cycleId?: string): Promise<any> {
  const dummy = { position: 0, total_positions: 0 };
  try {
    let payload = {};

    if (!!filter) {
      payload = { ...payload, ...filter };
    }

    if (!!cycleId) {
      payload = { ...payload, cycleId };
    }

    const { data } = await api.post(`find/pontos_online?time=${+new Date()}`, payload);

    if (!Array.isArray(data)) {
      return [];
    } else {
      if (data.length) {
        return data[0] as any;
      } else {
        return dummy;
      }
    }
  } catch (e) {
    return dummy;
  }
}

export async function getKPIPontosCultura(player?: string, filter?: any, start?: any, end?: any) {
  try {
    let payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
    };
    if (!!filter) {
      payload = { ...payload, ...filter };
    }

    const { data } = await api.post('find/pontos_cultura', payload);

    if (!Array.isArray(data)) {
      return null;
    } else {
      if (data?.length) {
        return data[0];
        // return data.reduce((value, item) => {
        //   if (item) {
        //     value[item._id] = item.total;
        //     return value;
        //   }
        //   return value;
        // }, {});
      } else {
        return null;
      }
    }
  } catch (e) {
    return null;
  }
}

export async function getResultadosCultura(search?: string, behavior?: string, rang?: number) {
  try {
    const payload = {
      search,
      behavior,
    };

    const rangeStart = rang ? rang : 0;

    const data = await api.post('find/resultado_cultura', payload, {
      headers: { Range: `items=${rangeStart}-20` },
    });

    return SortPagination(data);
  } catch (e) {
    throw e;
  }
}

export async function getResultadosCulturaSecond(search?: string, behavior?: string, rang?: number, cycle?: string) {
  try {
    const payload = {
      search,
      behavior,
      cycleId: cycle ? cycle : null,
    };

    const rangeStart = rang ? rang : 0;

    const data = await api.post('find/resultado_cultura_2', payload, {
      headers: { Range: `items=${rangeStart}-20` },
    });

    return SortPagination(data);
  } catch (e) {
    throw e;
  }
}

export async function getSeloRealizacao(search?: string, cycleId?: string, rang?: number, collection?: string, player?: string) {
  try {
    const payload = {
      search,
      cycleId,
      player,
    };

    const rangeStart = rang ? rang : 0;

    const data = await api.post(`find/${collection ? collection : 'selo_realizacao'}`, payload, {
      headers: { Range: `items=${rangeStart}-20` },
    });

    return SortPagination(data);
  } catch (e) {
    throw e;
  }
}

export async function getSeloRealizacaoDetail(player?: string, cycleId?: string) {
  try {
    const payload = {
      player,
      cycleId,
    };

    const { data } = await api.post(`find/realizacoes_coletivas_detail`, payload);

    return data;
  } catch (e) {
    throw e;
  }
}
export async function getResultadosByUser(player?: string, cycle?: string) {
  try {
    const payload = {
      player,
      cycleId: cycle ? cycle : null,
    };

    const { data } = await api.post('find/resultado_cultura_2', payload, {
      headers: { Range: `items=0-10` },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function getResultadosGaleriaReconhecimento(search?: string, rang?: number) {
  try {
    const payload = {
      search,
    };

    const rangeStart = rang ? rang : 0;
    const data = await api.post('find/resultado_galeria', payload, {
      headers: { Range: `items=${rangeStart}-20` },
    });

    return SortPagination(data);
  } catch (e) {
    throw e;
  }
}

export async function getResultadosGaleriaReconhecimentoSecond(search?: string, rang?: number, cycle?: string) {
  try {
    const payload = {
      search,
      cycleId: cycle ? cycle : null,
    };

    const rangeStart = rang ? rang : 0;
    const data = await api.post('find/resultado_galeria_2', payload, {
      headers: { Range: `items=${rangeStart}-20` },
    });

    return SortPagination(data);
  } catch (e) {
    throw e;
  }
}

export async function getGaleriaSecondByUser(player?: string, cycle?: any) {
  try {
    const payload = {
      player,
      cycleId: cycle ? cycle : null,
    };

    const { data } = await api.post('find/resultado_galeria_2', payload, {
      headers: { Range: `items=0-10` },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function getUserEquipeType() {
  try {
    const payload = {};

    const { data } = await api.post('find/get_user_equipe_type', payload, {
      headers: { Range: `items=0-10` },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data[0] as {
        _id: string;
        is_gestor: boolean;
        level: number;
        type: 'HIBRIDO' | 'PREDEFINIDO';
        has_hybrid_on_team: boolean;
      };
    }
  } catch (e) {
    throw e;
  }
}

export async function checkTeamsRecognition(): Promise<boolean> {
  try {
    const { data } = await api.post('find/check_teams_recognition', {});
    return Array.isArray(data) && data.length > 0 && data[0].total > 0;
  } catch (e) {
    return false;
  }
}

/**
 * Indica se o jogador já abriu ao menos 5 envelopes do Álbum BB 2026 — gatilho da
 * pesquisa de satisfação da campanha. Espelha `checkTeamsRecognition`: a rota custom
 * `check_copa_packs_opened` conta `action_log{actionId:"copa_open_pack"}` do jogador do
 * contexto e devolve `[{ total }]`. Falha resolve `false` para não bloquear o Dashboard.
 */
export async function checkCopaPacksOpened(): Promise<boolean> {
  try {
    const { data } = await api.post('find/check_copa_packs_opened', {});
    return Array.isArray(data) && data.length > 0 && data[0].total >= 5;
  } catch (e) {
    return false;
  }
}

export async function getSeloDestaque(player?: string, cycle?: any) {
  try {
    const payload = {
      player,
      cycleId: cycle ? cycle : null,
    };

    const { data } = await api.post('find/selo_realizacao_destaque_2', payload, {
      headers: { Range: `items=0-10` },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function getSelos() {
  try {
    const { data } = await api.post(
      'find/get_selos',
      {},
      {
        headers: { Range: `items=0-10` },
      },
    );

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function getUserByPrefixo(prefixo: number, search?: string, rang?: number, total?: number) {
  try {
    const payload = {
      search,
      prefixo,
    };

    const rangeStart = rang ? rang : 0;
    const data = await api.post('find/players_by_prefixo', payload, {
      headers: { Range: `items=${rangeStart}-${total ? total : 20}` },
    });

    return SortPagination(data);
  } catch (e) {
    throw e;
  }
}

export async function getEquieGestor(player: string, search?: string, rang?: number, total?: number) {
  try {
    const payload = {
      search,
      player,
    };

    const rangeStart = rang ? rang : 0;
    const data = await api.post('find/equipe_gestor', payload, {
      headers: { Range: `items=${rangeStart}-${total ? total : 20}` },
    });

    return SortPagination(data);
  } catch (e) {
    throw e;
  }
}

export async function getMembrosEquipeGestor(player: string) {
  try {
    const payload = {
      player,
    };

    const data = await api.post('find/subordinate_team', payload);

    return SortPagination(data);
  } catch (e) {
    throw e;
  }
}

export async function getGroup(cycleLabel?: string) {
  try {
    const payload = { cycleLabel };
    const { data } = await api.post('find/get_group', payload, {
      headers: { Range: 'items=0-1' },
    });
    if (!Array.isArray(data)) {
      return [];
    } else {
      return data[0];
    }
  } catch (e) {
    throw e;
  }
}

export async function getResultadosSelosBB() {
  try {
    const payload = {};
    const { data } = await api.post('find/resultado_selo', payload, {
      headers: { Range: 'items=0-10000' },
    });
    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function getCatalogoExtrato() {
  try {
    const payload = {};
    const { data } = await api.post('find/catalog_extract', payload, {
      headers: { Range: 'items=0-10000' },
    });
    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function getLiveloPoints(cycleId?: string) {
  try {
    const payload = {
      cycleId: cycleId ? cycleId : null,
    };
    const { data } = await api.post('find/livelo_points', payload, {
      headers: { Range: 'items=0-10000' },
    });
    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function getKPIHistory(player?: string, start?: any, end?: any, cycleId?: string) {
  try {
    const payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
      cycleId,
    };
    const { data } = await api.post('find/extrato', payload, {
      headers: { Range: 'items=0-1000' },
    });
    // console.log('getKPIHistorico', data);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

export async function getKPIHistoryPag(player?: string, filter?: any, rang?: number, total?: number, start?: any, end?: any) {
  try {
    let payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
    };

    if (!!filter) {
      payload = { ...payload, ...filter };
    }

    const rangeStart = rang ? rang : 0;

    const data = await api.post('find/extrato', payload, {
      headers: { Range: `items=${rangeStart}-${total ? total : 5}` },
    });
    // console.log('getKPIHistorico', data);
    return SortPagination(data);
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

export async function getKPIHistoryByTime(player?: string, start?: any, end?: any) {
  try {
    const payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
    };
    const { data } = await api.post('find/extrato_period', payload, {
      headers: { Range: 'items=0-1000' },
    });
    // console.log('getKPIHistorico', data);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

export async function getKPIPublicHistoryByTime(player?: string, start?: any, end?: any, cycleId?: any) {
  try {
    const payload = {
      player,
      start: start,
      end: end,
      cycleId,
    };
    const { data } = await api.post('find/public_extrato', payload, {
      headers: { Range: 'items=0-1000' },
    });
    // console.log('getKPIHistorico', data);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

export async function getKPISentHistory(
  player?: string,
  cycleId?: string,
  rang?: number,
  total?: number,
  start?: any,
  end?: any,
) {
  try {
    let payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
    };

    if (!!cycleId) {
      payload = { ...payload, ...{ cycleId: cycleId } };
    }

    const rangeStart = rang ? rang : 0;
    const data = await api.post('find/extrato_enviado', payload, {
      headers: { Range: `items=${rangeStart}-${total ? total : 5}` },
    });
    // console.log('getKPIHistorico', data);

    return SortPagination(data);
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

export async function getKPISentHistoryPag(player?: string, filter?: any, rang?: number, total?: number, start?: any, end?: any) {
  try {
    let payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
    };

    if (!!filter) {
      payload = { ...payload, ...filter };
    }

    const rangeStart = rang ? rang : 0;
    const data = await api.post('find/extrato_enviado', payload, {
      headers: { Range: `items=${rangeStart}-${total ? total : 5}` },
    });
    // console.log('getKPIHistorico', data);

    return SortPagination(data);
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

export async function getPlayerInfo(player?: string, cycle?: string | undefined | null, showPairs = false) {
  try {
    const payload = {
      player,
      cycle: cycle ? cycle : null,
      showPairs,
    };

    const { data } = await api.post(`find/info`, payload);

    if (!Array.isArray(data)) {
      return null;
    } else {
      return data[0];
    }
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

/**
 * Calendário de fases (com trimestre e ciclo embutidos), ordenado por `date_finish` desc.
 *
 * Lê o prepared aggregate `calendar_v2`, que serve a collection `cache_calendar_v2__c` —
 * materializada uma vez por dia pelo scheduler "Gerar cache do calendário calendar_v2" a partir
 * de `task_schedule__c` + `task_trimester__c` + `task_cycle__c`. Substitui o aggregate ad-hoc com
 * dois `$lookup` que cada sessão executava. O aggregate já ordena desc; `reverse = false` espelha.
 */
export async function getTaskCycles(reverse = true): Promise<CyclesInterface[]> {
  const { data } = await api.post('find/calendar_v2', {});

  if (!Array.isArray(data)) {
    return [];
  }

  return reverse ? data : [...data].reverse();
}

export async function getTaskCyclesFilter(ciclo?: string): Promise<CyclesInterface[]> {
  try {
    const payload = { ciclo };

    const { data } = await api.post('find/get_fase', payload);
    // console.log('getKPIHistorico', data);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

export async function getTasks(player?: string, start?: any, end?: any, ecoa = false, step?: number) {
  const endpoint = ecoa ? 'find/entregas_ecoa' : 'find/entregas';

  try {
    const payload = {
      player,
      start,
      end,
      step,
    };
    const { data } = await api.post(endpoint, payload, {
      headers: { Range: 'items=0-10000' },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

/** Realização Destaque excluída pelo próprio cadastrante, como a consulta `entregas_excluidas` devolve. */
export interface DeletedTask {
  _id: string;
  title?: string;
  /** Data de cadastro em ms. */
  created: number;
  deletion?: { time?: number; reason?: string };
}

/**
 * Exclusões do usuário logado cujo cadastro cai na janela da fase (spec `realizacoes-excluidas`).
 * O servidor decide o dono (jogador do token), a ordem e os campos.
 */
export async function getDeletedTasks(start: number, end: number): Promise<DeletedTask[]> {
  const { data } = await api.post('find/entregas_excluidas', { start, end }, { headers: { Range: 'items=0-100' } });

  return Array.isArray(data) ? data : [];
}

export async function getTotalTasks() {
  try {
    const payload = {};
    const { data } = await api.post('find/verify_total_tasks', payload, {
      headers: { Range: 'items=0-10000' },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data[0];
    }
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

export async function getTasksManager(player?: string, start?: any, end?: any, step?: number, taskId?: string) {
  try {
    const payload = {
      player: String(player),
      start,
      end,
      step: step ? step : null,
      taskId: taskId ? taskId : null,
    };
    const { data } = await api.post('find/tasks_manager', payload, {
      headers: { Range: 'items=0-10000' },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

export async function getTasksManagerQtd(player?: string, start?: any, end?: any, step?: number) {
  try {
    const payload = {
      player: String(player),
      start,
      end,
      step: step ? step : null,
    };
    const { data } = await api.post('find/tasks_manager_qtd', payload, {
      headers: { Range: 'items=0-10000' },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

export async function getTasksManagerEcoa(player?: string, start?: any, end?: any) {
  try {
    const payload = {
      player: String(player),
      start,
      end,
    };
    const { data } = await api.post('find/tasks_manager_ecoa', payload, {
      headers: { Range: 'items=0-10000' },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

/**
 * Exclui uma Ação ECOA. A Realização Destaque não usa mais DELETE direto: ela é excluída pelo
 * action_log `task_delete` (ver `requestTaskDeletion`).
 */
export async function deleteEcoaTask(id: string) {
  try {
    const endpoint = 'database/bb_task_ecoa__c';

    pushPlayerAction('deleteTask', {
      endpoint,
      data: {
        id,
        ecoa: true,
      },
      method: 'DELETE',
    });

    const { data } = await api.delete(`${endpoint}?q=_id:'${id}'`);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export interface TaskDeletionRequest {
  taskId: string;
  reason?: string;
  reasonOption?: DeleteReasonOption;
}

export interface TaskDeletionResult {
  ok: boolean;
  status: string;
  message: string;
}

/**
 * Pede a exclusão da Realização Destaque pelo action_log `task_delete`.
 *
 * A trigger da action valida dono, ciclo e motivo, copia o documento para `bb_task_deleted__c` e só
 * então o remove de `bb_task__c`, devolvendo o desfecho em `action.attributes`. Erro de rede ou HTTP é
 * relançado para a tela decidir a mensagem.
 */
export async function requestTaskDeletion({ taskId, reason, reasonOption }: TaskDeletionRequest): Promise<TaskDeletionResult> {
  const attributes = reason ? { taskId, reason, reasonOption } : { taskId };
  const response = await actionLog('me', 'task_delete', attributes);
  const outcome = response?.action?.attributes ?? {};
  const status = typeof outcome.status === 'string' ? outcome.status : 'ERROR';

  return {
    ok: status === 'OK',
    status,
    message: outcome.systemMessage || GENERIC_DELETE_ERROR_MESSAGE,
  };
}

export async function submitTask(payload: any) {
  try {
    const _payload = { ...payload };

    const serverTime = await getServerTime();

    if (!_payload.created) {
      _payload.created = { $date: serverTime };
    } else if (typeof _payload.created === 'number') {
      _payload.created = { $date: _payload.created };
    }

    _payload.updated = { $date: serverTime };

    if (typeof _payload.start === 'number') {
      _payload.start = { $date: _payload.start };
    }

    if (typeof _payload.end === 'number') {
      _payload.end = { $date: _payload.end };
    }

    // Informações trazidas pelo aggregate. Não precisa salvar na collection.
    delete _payload.owner_name;
    delete _payload.owner_tipo_classificacao;
    delete _payload.owner_avatar;
    delete _payload.target;
    delete _payload.feedback;
    delete _payload.evaluator_detail;
    delete _payload.gestores;
    delete _payload.answeredQuiz;
    delete _payload.original_manager_detail;
    delete _payload.now;
    delete _payload.mad_manager_appreciated;
    delete _payload.non_evaluator_detail;

    delete _payload.points;
    delete _payload.humanStatus;
    delete _payload.stepLabel;
    delete _payload.status_validation;
    delete _payload.lastEvaluator;
    delete _payload.statuses;
    delete _payload.qtdTeam;
    delete _payload.mad;
    delete _payload.owner_coe;

    pushPlayerAction('submitTask', {
      endpoint: 'database/bb_task__c',
      data: _payload,
      method: 'POST',
    });

    const { data } = await api.post('database/bb_task__c', _payload);
    return data;
  } catch (e) {
    throw e;
  }
}

export async function CheckTotalTasksParticipationMember(
  playerId?: string,
  targetPlayerId?: string,
  startCycle?: number,
  endCycle?: number,
) {
  try {
    const startDate = startCycle ? new Date(startCycle) : undefined;
    const endDate = endCycle ? new Date(endCycle) : undefined;

    const _payload = {
      playerId: playerId,
      targetPlayerId: targetPlayerId,
      startCycle: startDate,
      endCycle: endDate,
    };

    const { data } = await api.post('find/check_tasks_participation_member', _payload);
    return data;
  } catch (e) {
    throw e;
  }
}

export async function submitTaskEcoa(payload: any) {
  try {
    const _payload = { ...payload };

    const serverTime = await getServerTime();

    if (!_payload.created) {
      _payload.created = { $date: serverTime };
    } else if (typeof _payload.created === 'number') {
      _payload.created = { $date: _payload.created };
    }

    _payload.updated = { $date: serverTime };

    if (typeof _payload.start === 'number') {
      _payload.start = { $date: _payload.start };
    }

    if (typeof _payload.end === 'number') {
      _payload.end = { $date: _payload.end };
    }

    // Informações trazidas pelo aggregate. Não precisa salvar na collection.
    delete _payload.owner_name;
    delete _payload.owner_tipo_classificacao;
    delete _payload.owner_avatar;
    delete _payload.target;
    delete _payload.feedback;
    delete _payload.evaluator_detail;
    delete _payload.gestores;
    delete _payload.answeredQuiz;
    delete _payload.original_manager_detail;
    delete _payload.now;

    pushPlayerAction('submitTaskEcoa', {
      endpoint: 'database/bb_task_ecoa__c',
      data: _payload,
      method: 'POST',
    });

    const { data } = await api.post('database/bb_task_ecoa__c', _payload);
    return data;
  } catch (e) {
    throw e;
  }
}

export async function updateTask(payload: any) {
  try {
    const _payload = { ...payload };

    const serverTime = await getServerTime();

    if (!_payload.created) {
      _payload.created = { $date: serverTime };
    } else if (typeof _payload.created === 'number') {
      _payload.created = { $date: _payload.created };
    }

    _payload.updated = { $date: serverTime };

    if (typeof _payload.start === 'number') {
      _payload.start = { $date: _payload.start };
    }

    if (typeof _payload.end === 'number') {
      _payload.end = { $date: _payload.end };
    }

    // Informações trazidas pelo aggregate. Não precisa salvar na collection.
    delete _payload.owner_name;
    delete _payload.owner_tipo_classificacao;
    delete _payload.owner_avatar;
    delete _payload.target;
    delete _payload.feedback;
    delete _payload.evaluator_detail;
    delete _payload.gestores;
    delete _payload.answeredQuiz;
    delete _payload.original_manager_detail;
    delete _payload.now;
    delete _payload.mad_manager_appreciated;
    delete _payload.non_evaluator_detail;

    delete _payload.points;
    delete _payload.humanStatus;
    delete _payload.stepLabel;
    delete _payload.status_validation;
    delete _payload.lastEvaluator;
    delete _payload.statuses;
    delete _payload.qtdTeam;
    delete _payload.mad;
    delete _payload.owner_coe;

    pushPlayerAction('updateTask', {
      endpoint: 'database/bb_task__c',
      data: _payload,
      method: 'PUT',
    });

    const { data } = await api.put('database/bb_task__c', _payload);
    return data;
  } catch (e) {
    throw e;
  }
}

export async function updateTaskEcoa(payload: any) {
  try {
    const _payload = { ...payload };

    const serverTime = await getServerTime();

    if (!_payload.created) {
      _payload.created = { $date: serverTime };
    } else if (typeof _payload.created === 'number') {
      _payload.created = { $date: _payload.created };
    }

    _payload.updated = { $date: serverTime };

    if (typeof _payload.start === 'number') {
      _payload.start = { $date: _payload.start };
    }

    if (typeof _payload.end === 'number') {
      _payload.end = { $date: _payload.end };
    }

    // Informações trazidas pelo aggregate. Não precisa salvar na collection.
    delete _payload.owner_name;
    delete _payload.owner_tipo_classificacao;
    delete _payload.owner_avatar;
    delete _payload.target;
    delete _payload.feedback;
    delete _payload.evaluator_detail;
    delete _payload.gestores;
    delete _payload.answeredQuiz;
    delete _payload.original_manager_detail;
    delete _payload.now;

    pushPlayerAction('updateTaskEcoa', {
      endpoint: 'database/bb_task_ecoa__c',
      data: _payload,
      method: 'PUT',
    });

    const { data } = await api.put('database/bb_task_ecoa__c', _payload);
    return data;
  } catch (e) {
    throw e;
  }
}

export async function getVerifyTaskEcoa() {
  try {
    const { data } = await api.post('find/verify_ecoa', {});
    if (!Array.isArray(data)) {
      return [];
    } else {
      return data[0];
    }
  } catch (e) {
    throw e;
  }
}

export async function getTaskById(id: any) {
  try {
    if (!id) return;
    const { data } = await api.post('find/task', { id });
    if (!Array.isArray(data)) {
      return [];
    } else {
      return data[0];
    }
  } catch (e) {
    throw e;
  }
}

export async function getTaskByIdEcoa(id: any) {
  try {
    if (!id) return;
    const { data } = await api.post('find/task_ecoa', { id });
    if (!Array.isArray(data)) {
      return [];
    } else {
      return data[0];
    }
  } catch (e) {
    throw e;
  }
}

export async function verifyTask(task: any) {
  try {
    const { data } = await api.post('find/verify_task', { task });
    if (!Array.isArray(data)) {
      return [];
    } else {
      return data[0];
    }
  } catch (e) {
    throw e;
  }
}

export async function getNextManagers(id: string) {
  try {
    if (!id) return null;

    const { data } = await api.post('find/next_managers', { id });

    if (Array.isArray(data) && data.length && data[0].next_managers) {
      return data[0].next_managers;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
}

export async function getTasksNeedingApproval(player?: string) {
  try {
    const { data } = await api.post('find/tasks_needing_approval', { player });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    return [];
  }
}

export async function hasManagersOnMyTeam(player?: string): Promise<boolean> {
  try {
    const { data } = await api.post('find/has_managers_on_my_team', { player });

    if (!Array.isArray(data)) {
      return false;
    } else {
      return data[0].hasMembers;
    }
  } catch (e) {
    return false;
  }
}

export async function getConfig(id: string): Promise<any[]> {
  try {
    const { data } = await api.get(`database/config__c/${id}`);
    return data;
  } catch (e) {
    throw e;
  }
}

export async function getUserGroup(player: string): Promise<UserGroupInterface[]> {
  try {
    const { data } = await api.post(`find/user_group`, {});

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    return [];
  }
}

export async function getUserGroupList(player?: string, cycleLabel?: string): Promise<unknown[]> {
  try {
    const { data } = await api.post(
      `find/group_list`,
      {
        player: player ? player : null,
        cycleLabel: cycleLabel ? cycleLabel : null,
      },
      {
        headers: { Range: 'items=0-2000' },
      },
    );

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    return [];
  }
}

export async function sendInvite(payload: InviteInterface): Promise<InviteInterface> {
  try {
    const { data } = await api.post('database/invite__c', payload);
    return data;
  } catch (e) {
    throw e;
  }
}

export async function checkInvite(player: string, sender: string): Promise<boolean> {
  try {
    const { data } = await api.post('find/check_invite', { player, sender });

    if (!Array.isArray(data)) {
      return false;
    } else {
      if (data.length && data[0].total > 0) {
        return true;
      } else {
        return false;
      }
    }
  } catch (e) {
    return false;
  }
}

export async function submitFeedback(payload: any) {
  try {
    const serverTime = await getServerTime();

    payload.created = serverTime;

    pushPlayerAction('submitFeedback', {
      endpoint: 'database/bb_task_feedback__c',
      data: payload,
      method: 'POST',
    });

    const { data } = await api.post('database/bb_task_feedback__c', payload);
    return data;
  } catch (e) {
    throw e;
  }
}

export async function submitFeedbackEcoa(payload: any) {
  try {
    const serverTime = await getServerTime();

    payload.created = serverTime;

    pushPlayerAction('submitFeedbackEcoa', {
      endpoint: 'database/bb_task_ecoa_feedback__c',
      data: payload,
      method: 'POST',
    });

    const { data } = await api.post('database/bb_task_ecoa_feedback__c', payload);
    return data;
  } catch (e) {
    throw e;
  }
}

export async function playerHasFeedback(taskId: string, evaluatorId: string): Promise<boolean> {
  if (!taskId || !evaluatorId) return false;

  try {
    const payload = [
      {
        $match: {
          evaluatorId,
          taskId,
        },
      },
    ];

    const { data } = await api.post('database/bb_task_feedback__c/aggregate', payload);

    if (!Array.isArray(data)) {
      return false;
    } else {
      return !!data.length;
    }
  } catch (e) {
    return false;
  }
}

export async function deleteMissionFeedback(taskId: string): Promise<boolean> {
  try {
    pushPlayerAction('deleteMissionFeedback', {
      endpoint: `database/bb_task_feedback__c?q=taskId:'${taskId}'`,
      data: {
        taskId,
      },
      method: 'DELETE',
    });

    const { data } = await api.delete(`database/bb_task_feedback__c?q=taskId:'${taskId}'`);

    if (!Array.isArray(data)) {
      return false;
    } else {
      return !!data.length;
    }
  } catch (e) {
    return false;
  }
}

export async function getRealCycles(): Promise<any> {
  try {
    const { data } = await api.post(
      `find/get_cycles`,
      {},
      {
        headers: { Range: 'items=0-10000' },
      },
    );

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    return [];
  }
}

export async function getCyclesExtended(): Promise<any> {
  try {
    const { data } = await api.post(
      `find/get_cycles_extended`,
      {},
      {
        headers: { Range: 'items=0-10000' },
      },
    );

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    return [];
  }
}

export async function deleteFeedbackByQuery(query: string): Promise<boolean> {
  try {
    pushPlayerAction('deleteFeedbackByQuery', {
      endpoint: `database/bb_task_feedback__c?q=${query}`,
      data: {
        query,
      },
      method: 'DELETE',
    });

    const { data } = await api.delete(`database/bb_task_feedback__c?q=${query}`);

    if (!Array.isArray(data)) {
      return false;
    } else {
      return true;
    }
  } catch (e) {
    return false;
  }
}

export async function deleteFeedbackEcoaByQuery(query: string): Promise<boolean> {
  try {
    pushPlayerAction('deleteFeedbackEcoaByQuery', {
      endpoint: `database/bb_task_ecoa_feedback__c?q=${query}`,
      data: {
        query,
      },
      method: 'DELETE',
    });

    const { data } = await api.delete(`database/bb_task_ecoa_feedback__c?q=${query}`);

    if (!Array.isArray(data)) {
      return false;
    } else {
      return true;
    }
  } catch (e) {
    return false;
  }
}

export async function playerLastManager(player: string): Promise<LastManagerInterface | null> {
  if (!player) return null;

  try {
    const { data } = await api.post('find/get_last_manager', { player });

    if (!Array.isArray(data)) {
      return null;
    } else {
      return data.length ? data[0] : null;
    }
  } catch (e) {
    return null;
  }
}

export async function getVacationManager(player: string | undefined): Promise<VacationManagerInterface[] | null> {
  if (!player) return null;

  try {
    const { data } = await api.post('find/vacation_manager', { player });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    return null;
  }
}

export async function getNumberParticipationsEvaluated(player?: string): Promise<ParticipationsEvaluated_Interface | null> {
  try {
    const { data } = await api.post('find/n_rejected_participations', { player });

    if (!Array.isArray(data)) {
      return null;
    } else {
      return data.length ? data[0] : null;
    }
  } catch (e) {
    return null;
  }
}

export async function getTasksNeedingApprovalParticipants(start?: any, end?: any, player?: string) {
  try {
    const payload: any = {
      start,
      end,
    };

    if (typeof player === 'string') {
      payload.player = player;
    }

    const { data } = await api.post('find/need_approval_participants', payload);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    return [];
  }
}

export async function getTasksEvaluator(player?: string, start?: any, end?: any, step?: number) {
  try {
    const payload = {
      player: String(player),
      start,
      end,
      step: step ? step : null,
    };

    const { data } = await api.post('find/tasks_manager_non_evaluator', payload);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    return [];
  }
}

export async function getTasksPendingApprovalParticipants(player?: string) {
  try {
    const payload: any = {};

    if (typeof player === 'string') {
      payload.player = player;
    }

    const { data } = await api.post('find/pending_approval_participants', payload);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    return [];
  }
}

export async function getTasksOtherIndicator() {
  try {
    const { data } = await api.post('find/get_task_other_indicator', {});

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    return [];
  }
}

export async function getServerTime(): Promise<number> {
  const { data } = await api.post(
    `database/task_schedule__c/aggregate`,
    [
      {
        $facet: {
          data: [
            {
              $match: {
                _id: 'IDInexistenteParaPegarHoraDoServidor',
              },
            },
            {
              $project: {
                _id: 1,
              },
            },
          ],
        },
      },
      {
        $project: {
          server_time: {
            $ifNull: [
              {
                $arrayElemAt: ['$data._id', 0],
              },
              '$$NOW',
            ],
          },
        },
      },
    ],
    {
      headers: { Range: 'items=0-10000' },
    },
  );

  return data[0].server_time;
}

export async function getBonus(player: string) {
  try {
    const payload = {
      player,
      created: { $date: new Date().getTime() },
      updated: { $date: new Date().getTime() },
    };

    const { data } = await api.post('database/card_bonus__c', payload);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    return [];
  }
}

export async function verifyBonus(cycleId?: string) {
  try {
    const payload = {
      cycleId: cycleId ? cycleId : null,
    };

    const { data } = await api.post('find/verify_bonus', payload);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data?.[0];
    }
  } catch (e) {
    return [];
  }
}

export async function verifyGame(gameId?: string) {
  try {
    const payload = {
      game: gameId ? gameId : null,
    };

    const { data } = await api.post('find/game_score', payload);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data?.[0];
    }
  } catch (e) {
    return [];
  }
}

export async function sendNotificationTask(payload: any) {
  try {
    const _payload = { ...payload };

    const { data } = await api.put('database/task_user_limit_notification__c', _payload);
    return data;
  } catch (e) {
    throw e;
  }
}

export async function sendPreferenceNotification(payload: any) {
  try {
    const _payload = { ...payload };

    const { data } = await api.put('database/preference_notification__c', _payload);
    return data;
  } catch (e) {
    throw e;
  }
}

export async function sendPartialTask(payload: any) {
  const _payload = payload ? { ...payload } : {};
  try {
    const { data } = await api.post('database/bb_task_partial__c', _payload);
    return data;
  } catch (e) {
    return null;
  }
}

export async function deletePartialTask(player: string) {
  if (!player) return null;

  try {
    const { data } = await api.delete(`database/bb_task_partial__c?q=_id:'${player}'`);
    return data;
  } catch (e) {
    return null;
  }
}

export async function getPartialTask() {
  try {
    const { data } = await api.post('find/get_partial_task', {});

    if (!Array.isArray(data) || !data.length) {
      return null;
    } else {
      return data[0];
    }
  } catch (e) {
    return null;
  }
}

export async function sendPartialRecognition(payload: any) {
  const _payload = payload ? { ...payload } : {};
  try {
    const { data } = await api.put('database/bb_recognition_partial__c', _payload);
    return data;
  } catch (e) {
    return null;
  }
}

export async function getPartialRecognition() {
  try {
    const { data } = await api.post('find/get_partial_recognition', {});

    if (!Array.isArray(data) || !data.length) {
      return null;
    } else {
      return data[0];
    }
  } catch (e) {
    return null;
  }
}

// Variante do getTasksManager restrita ao universo do fluxo Diretoria/Rede.
export async function getTasksManagerNormal(player?: string, start?: any, end?: any, step?: number, taskId?: string) {
  try {
    const payload = {
      player: String(player),
      start,
      end,
      step: step ? step : null,
      taskId: taskId ? taskId : null,
    };
    const { data } = await api.post('find/tasks_manager_normal', payload, {
      headers: { Range: 'items=0-10000' },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

// Variante do getTasksManager restrita ao universo do fluxo MAD.
export async function getTasksManagerMad(player?: string, start?: any, end?: any, step?: number, taskId?: string) {
  try {
    const payload = {
      player: String(player),
      start,
      end,
      step: step ? step : null,
      taskId: taskId ? taskId : null,
    };
    const { data } = await api.post('find/tasks_manager_mad', payload, {
      headers: { Range: 'items=0-10000' },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export interface FlowEligibilityResult {
  normal: boolean;
  mad: boolean;
  normalPending?: number;
  madPending?: number;
}

// Contagem devolvida pelo aggregate: só aceita número não-negativo; qualquer outra coisa
// (campo ausente no runtime antigo, token de $param não substituído) vira undefined, e o
// consumidor faz fallback ao comportamento sem pendência.
function parsePendingCount(value: unknown): number | undefined {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : undefined;
}

// Elegibilidade aos fluxos de apreciação. O aggregate responde
// [{ normal: 0|1, mad: 0|1, normal_pending?: number, mad_pending?: number }].
// Lista VAZIA é resposta resolvida = sem acesso (chamador não-gestor/inativo) e vira
// { normal: false, mad: false }; null fica reservado para ERRO de rede/servidor — o
// gate mostra "tentar novamente" no null e "sem acesso" no resolvido.
// `cycleId` responde "NESTE ciclo, quais fluxos existem para mim?" — a página de apreciação
// navega o histórico inteiro pelo seletor de ciclos, então a elegibilidade acompanha a
// seleção. Omitido, o aggregate cai no ciclo corrente (comportamento anterior).
export async function getFlowEligibility(player?: string, cycleId?: string): Promise<FlowEligibilityResult | null> {
  try {
    const { data } = await api.post('find/apreciacao_flow_eligibility', { player, cycleId });

    if (!Array.isArray(data)) {
      return null;
    }

    if (!data.length) {
      return { normal: false, mad: false };
    }

    const [eligibility] = data;

    return {
      normal: eligibility?.normal === 1 || eligibility?.normal === true,
      mad: eligibility?.mad === 1 || eligibility?.mad === true,
      normalPending: parsePendingCount(eligibility?.normal_pending),
      madPending: parsePendingCount(eligibility?.mad_pending),
    };
  } catch (e) {
    return null;
  }
}

// Busca de gestores elegíveis a dupla MAD (find/gestores_mad). O termo de busca é
// repassado como recebido — normalizações ficam a cargo do chamador.
export async function findManagersMad(search?: string, cod?: number[]) {
  try {
    const payload = {
      search,
      cod,
    };

    const { data } = await api.post('find/gestores_mad', payload);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}
